exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 5px 15px; }\n\n.card-title {\n  font-size: 18px;\n  margin-bottom: 0 !important; }\n\n.provider-row {\n  height: 50px;\n  line-height: 30px;\n  background: #dee7ff;\n  width: 100%;\n  padding-left: 15px;\n  padding: 10px 0 10px 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/frames/agency-providers/agency-providers.component.scss
// module id = ../../../../../src/app/main/frames/agency-providers/agency-providers.component.scss
// module chunks = main